import { AbonementeResponse } from '@/types/service-response'

export class CommissionSubscription {
  public constructor (
    readonly id: number,
    readonly titel: string,
    readonly ihreReferenz: string,
    readonly kommission: number,
    readonly lieferkondition: number,
    readonly periode: number,
    readonly prozessArt: number,
    readonly start: string | null,
    readonly ende: string | null,
    readonly versandart: number,
    readonly zahlungskondition: number,
    readonly projekt: number | null
  ) {}

  static createFromResponse (item: AbonementeResponse): CommissionSubscription {
    return new CommissionSubscription(
      item.ID,
      item.Titel ? item.Titel : '',
      item.IhreReferenz ? item.IhreReferenz : '',
      item.Kommission,
      item.Lieferkondition,
      item.Periode,
      item.ProzessArt,
      item.Start,
      item.Ende,
      item.Versandart,
      item.Zahlungskondition,
      item.Projekt
    )
  }

  static createListFromResponse (responseData: AbonementeResponse[]): Array<CommissionSubscription> {
    return responseData.map((item: AbonementeResponse ) => {
      return new CommissionSubscription(
        item.ID,
        item.Titel ? item.Titel : '',
        item.IhreReferenz ? item.IhreReferenz : '',
        item.Kommission,
        item.Lieferkondition,
        item.Periode,
        item.ProzessArt,
        item.Start,
        item.Ende,
        item.Versandart,
        item.Zahlungskondition,
        item.Projekt
      )
    })
  }
}
